const styles = () => ({
  formToggles: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    width: 175,
    height: 36,
    borderRadius: 8,
    border: 'solid 1px #eff2f4',
    userSelect: 'none',
  },

  formToggle: {
    backgroundColor: '#fbfcfd',
    color: '#b3bdc8',
    fontSize: 15,
    fontWeight: 500,
    height: 34,
    lineHeight: '34px',
    textAlign: 'center',
    width: 85,
  },

  formToggleBorderLeft: {
    borderRadius: '8px 0 0 8px',
  },

  formToggleBorderRight: {
    borderRadius: '0 8px 8px 0',
  },

  formToggleActive: {
    color: '#32383f',
    backgroundColor: '#ffffff',
  },
});

export default styles;
